function DefaultAvatarLogo({ className = "", size = 80, title = "Default profile avatar" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 80 80"
      className={className}
      role="img"
      aria-label={title}
    >
      <circle cx="40" cy="40" r="39" fill="#1e293b" stroke="#475569" strokeWidth="1" />
      <circle cx="40" cy="31" r="11.5" fill="#cbd5f5" />
      <path d="M18 63c3.2-9.8 11-15 22-15s18.8 5.2 22 15" fill="none" stroke="#cbd5f5" strokeWidth="6.5" strokeLinecap="round" />
    </svg>
  );
}

export default DefaultAvatarLogo;
